export default "__VITE_ASSET__rAlTJCPF__"